import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counterSlice';
import settingsReducer from './settingsSlice';
import statesReducer from './statesSlice';
import districtsReducer from './districtsSlice';
import packageReducer from './packageSlice';
import homeReducer  from './homeSlice';
import adReducer from './adSlice';
import subLocalityReducer from './subLocalitySlice';
import popularLocalityReducer from './popularLocalitySlice';
import profilePropertyReducer   from './profilePropertySlice';
const store = configureStore({
  reducer: {
    counter: counterReducer,
    settings: settingsReducer,
    states: statesReducer,
    districts: districtsReducer,
    home: homeReducer,
    package: packageReducer,
    ads: adReducer,
    subLocalities: subLocalityReducer,
    popularLocalities: popularLocalityReducer,
    profileProperty: profilePropertyReducer ,
  },
});

export default store;
